const PRIVATE = "PRIVATE";
const AUTO = "AUTO";
const MANUAL = "MANUAL";

export { PRIVATE, AUTO, MANUAL };
